// Parrilla Coreana — scripts propios (prefijo pc-)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initCarruseles();
  initSticky();
  initIrCompra();
  initContadores();
});

// Botones "ir a comprar": bajan hasta el bloque de compra ---------------------
function initIrCompra() {
  document.querySelectorAll('[data-pc-ir-compra]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var destino = document.querySelector('.pc-compra');
      if (!destino) return;
      var y = destino.getBoundingClientRect().top + window.pageYOffset - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
}

// Cifras que suben contando al aparecer (ej. "17,7%") -------------------------
function initContadores() {
  var els = [].slice.call(document.querySelectorAll('[data-pc-contador]'));
  if (!els.length) return;

  function contar(el) {
    var texto = el.getAttribute('data-pc-contador') || '';
    var m = texto.match(/-?\d+(?:[.,]\d+)?/);
    if (!m) return;
    var decimales = (m[0].split(/[.,]/)[1] || '').length;
    var meta = parseFloat(m[0].replace(',', '.'));
    var antes = texto.slice(0, m.index);
    var despues = texto.slice(m.index + m[0].length);
    var inicio = null;
    var duracion = 1400;
    function paso(t) {
      if (inicio === null) inicio = t;
      var p = Math.min((t - inicio) / duracion, 1);
      var valor = meta * (1 - Math.pow(1 - p, 3));
      el.textContent = antes + valor.toFixed(decimales).replace('.', ',') + despues;
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = texto;
    }
    requestAnimationFrame(paso);
  }

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { contar(e.target); obs.unobserve(e.target); }
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

// Animación de entrada ------------------------------------------------------
function initReveal() {
  var els = [].slice.call(document.querySelectorAll('.pc-reveal'));
  if (!els.length) return;

  function mostrar(el) { el.classList.add('pc-visible'); }

  if (!('IntersectionObserver' in window)) {
    els.forEach(mostrar);
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { mostrar(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  els.forEach(function (el) { obs.observe(el); });

  // Red de seguridad: con scroll rápido el observer se salta elementos y esos
  // bloques se quedarían invisibles. Barremos también en cada scroll.
  var pendientes = els;
  var encolado = false;

  function barrer() {
    encolado = false;
    var limite = window.innerHeight * 0.95;
    pendientes = pendientes.filter(function (el) {
      if (el.classList.contains('pc-visible')) return false;
      if (el.getBoundingClientRect().top < limite) { mostrar(el); obs.unobserve(el); return false; }
      return true;
    });
    if (!pendientes.length) {
      window.removeEventListener('scroll', alMover);
      window.removeEventListener('resize', alMover);
    }
  }

  function alMover() {
    if (encolado) return;
    encolado = true;
    requestAnimationFrame(barrer);
  }

  window.addEventListener('scroll', alMover, { passive: true });
  window.addEventListener('resize', alMover, { passive: true });
  barrer();
}

// Galería del producto: la miniatura cambia la foto principal ---------------
function initGaleria() {
  document.querySelectorAll('[data-pc-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-pc-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-pc-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var grande = mini.getAttribute('data-full');
        if (!grande) return;
        principal.src = grande;
        principal.srcset = '';
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      });
    });
  });
}

// Carruseles (galería y reseñas): flechas + puntos --------------------------
function initCarruseles() {
  document.querySelectorAll('[data-pc-carrusel]').forEach(function (wrap) {
    var pista = wrap.querySelector('.pc-carrusel');
    if (!pista) return;
    var slides = [].slice.call(pista.children);
    if (slides.length < 2) {
      var ctrl = wrap.querySelector('.pc-carrusel-controles');
      if (ctrl) ctrl.style.display = 'none';
      return;
    }

    var puntos = [].slice.call(wrap.querySelectorAll('[data-pc-punto]'));
    var anterior = wrap.querySelector('[data-pc-anterior]');
    var siguiente = wrap.querySelector('[data-pc-siguiente]');

    function indiceActual() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var mejor = 0;
      var mejorDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - centro);
        if (d < mejorDist) { mejorDist = d; mejor = i; }
      });
      return mejor;
    }

    function irA(i) {
      var destino = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (destino) pista.scrollTo({ left: destino.offsetLeft, behavior: 'smooth' });
    }

    function pintar() {
      var actual = indiceActual();
      puntos.forEach(function (p, i) { p.setAttribute('aria-current', i === actual ? 'true' : 'false'); });
    }

    if (anterior) anterior.addEventListener('click', function () { irA(indiceActual() - 1); });
    if (siguiente) siguiente.addEventListener('click', function () { irA(indiceActual() + 1); });
    puntos.forEach(function (p, i) { p.addEventListener('click', function () { irA(i); }); });

    var encolado = false;
    pista.addEventListener('scroll', function () {
      if (encolado) return;
      encolado = true;
      requestAnimationFrame(function () { encolado = false; pintar(); });
    }, { passive: true });

    pintar();
  });
}

// Botón fijo: aparece cuando el botón principal sale de pantalla ------------
function initSticky() {
  var sticky = document.querySelector('[data-pc-sticky]');
  var referencia = document.querySelector('[data-pc-boton-principal]');
  if (!sticky || !referencia) return;

  function evaluar() {
    var r = referencia.getBoundingClientRect();
    // Visible cuando el botón principal ya quedó por encima de la pantalla.
    var mostrar = r.bottom < 0;
    sticky.classList.toggle('pc-sticky-visible', mostrar);
  }

  var encolado = false;
  function alMover() {
    if (encolado) return;
    encolado = true;
    requestAnimationFrame(function () { encolado = false; evaluar(); });
  }

  window.addEventListener('scroll', alMover, { passive: true });
  window.addEventListener('resize', alMover, { passive: true });
  evaluar();
}
